import { useState } from 'react';

export default function ServicesSection() {
  const [activeService, setActiveService] = useState(0);

  const services = [
    {
      title: 'Legal Research & Regulatory Advisory',
      // Use template literals to preserve line breaks without causing syntax errors
      content: `Interpretation of legislation, sectoral regulations, and administrative procedures

Legal compliance advisory and risk assessment

Regulatory due diligence for projects, investments, and partnerships`,
    },
    {
      title: 'Business Environment & Market Entry Advisory',
      content: `Assessment of legal, regulatory, and operational risks

Guidance on investment frameworks and licensing requirements

Strategic advice for market entry and operations in Angola, Lusophone Africa and SADC.`,
    },
    {
      title: 'Institutional & Government Engagement Strategy',
      content: `Stakeholder mapping and institutional profiling

Guidance on navigating ministries, regulators, and public institutions

Development of strategic engagement plans and approval pathways`,
    },
    {
      title: 'Policy Analysis & Strategic Advisory',
      content: `In-depth legal research on domestic and international regulatory frameworksInterpretation of national and sectoral policiesAlignment of organizational objectives with governance prioritiesDevelopment of frameworks for efficient and sustainable operationsPolicy analysis and legislative review for informed decision-making
Preparation of legal opinions, memoranda, and compliance reports`,
    },
    {
      title: 'Contract Drafting & Negotiation Support',
      content: `Drafting, reviewing, and negotiating commercial and legal agreements

Advisory on contractual obligations, rights, and risk allocation

Support for joint ventures, partnerships, and cross-border transactions

Review of standard terms and conditions for regulatory compliance`,
    },
    {
      title: 'Capacity Building & Legal Training',
      content: `Design and delivery of tailored legal and regulatory training programs

Workshops and seminars for organizations, teams, and professionals

Development of internal compliance frameworks and governance policies

Training on applicable laws, regulatory requirements, and best practices

Support for building in-house legal capacity and institutional knowledge`,
    },
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-light text-stone-900 mb-4">
            Legal Services
          </h2>
          <p className="text-stone-600 font-light max-w-2xl mx-auto">
            Professional legal solutions tailored to meet your specific needs
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div className="space-y-6">
            {services.map((service, index) => (
              <div key={index} className="border-b border-stone-200 pb-6">
                <button
                  onClick={() =>
                    setActiveService(activeService === index ? -1 : index)
                  }
                  className="w-full text-left flex items-center justify-between cursor-pointer"
                >
                  <h3 className="text-xl font-medium text-stone-900">
                    {service.title}
                  </h3>
                  <i
                    className={`ri-${activeService === index ? 'subtract' : 'add'}-line text-stone-600`}
                  ></i>
                </button>

                {activeService === index && (
                  <div className="mt-4">
                    <p className="text-stone-600 font-light leading-relaxed whitespace-pre-line">
                      {service.content}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="relative">
            <img
              src="https://static.readdy.ai/image/000745ea5477ac1971ad11ea6f2dc4d7/9f615a683eafbe1d516e320cbbf491d2.jpeg"
              alt="Professional legal workspace"
              className="w-full h-80 object-cover object-top rounded-lg shadow-sm"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
